// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { SortingState } from '@teamnine/pcj-ui-v2'

import ActivePracticesView from '@/app/CustomerManagement/views/ActivePracticesView'
import { CustomerOutletContext } from './types'

export default function ActivePractices() {
  const { practices, currentCustomer, isLoading } =
    useOutletContext<CustomerOutletContext>()
  const [searchString, setSearchString] = useState('')
  const [practiceSortState, setPracticeSortState] = useState<SortingState>([])
  const [practicesPageIndex, setPracticesPageIndex] = useState(0)

  const handleSearch = (val: string[]) => {
    setSearchString(val[0])
    setPracticesPageIndex(0)
  }

  return (
    <ActivePracticesView
      practices={practices}
      currentCustomer={currentCustomer}
      isLoading={isLoading}
      searchString={searchString}
      practiceSortState={practiceSortState}
      practicesPageIndex={practicesPageIndex}
      onSortingChange={setPracticeSortState}
      onPageChange={setPracticesPageIndex}
      onSearch={handleSearch}
    />
  )
}
